<template>
    <div>
        <v-data-table
                :disable-initial-sort="true"
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="total"
                :loading="isLoading"
                :rows-per-page-items="[10,25,50,100]"
                :no-data-text="trans('app.search.no_data')"
        >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template #items="props">
                <slot name="content" :item="props.item"></slot>
            </template>
        </v-data-table>

        <div class="text-xs-center pt-2 pb-4">
            <v-pagination v-model="pagination.page" total-visible=10 :length="pages"></v-pagination>
        </div>
    </div>
</template>
<style scoped>
.v-datatable tr td:last-child {
  display: table-cell !important;
}
</style>
<script>
  import debounce from 'lodash/debounce';
  import { stringify } from 'qs';

  export default {
    props: {
      headers: Array,
      filters: Object,
      endpoint: String,
    },
    data: () => ({
      isLoading: false,
      pages: 0,
      total: 0,
      pagination: {},
      items: [],
    }),
    watch: {
      pagination: {
        handler() {
          this.fetchData();
        },
        deep: true,
      },
      filters: {
        handler() {
          this.debounceFetch();
        },
        deep: true,
      },
    },
    created() {
      this.debounceFetch = debounce(this.fetchData, 300);
    },
    methods: {
      async fetchData() {
        this.isLoading = true;
        const { sortBy, descending, page, rowsPerPage } = this.pagination;

        const query = {
          page: page,
          perPage: rowsPerPage,
          orderBy: sortBy,
          dir: descending ? 'asc' : 'desc',
          ...this.filters,
        };

        const response = await axios.get(`${this.endpoint}?${stringify(query, { skipNulls: true })}`);

        const { data, meta } = response.data;

        this.items = data;
        this.total = meta.total;
        this.pages = meta.last_page;
        this.isLoading = false;

        this.$emit('dataLoaded', { items: data });
      },
      resetSearch() {
        this.filters = {};
      },
    },

  };
</script>
